export default __webpack_public_path__ + "static/media/2504152.44fba71a.jpg";